module.exports = __webpack_public_path__ + "media/2022/success-sweepstakes-winner-12931cd7.jpg";